/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_Speed_Desc5Inputs */

const en_svc_ai_app_rescue_speed_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Speed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slow queries, heavy bundles and blocking renders fixed against measured budgets.`)
};

const ar_svc_ai_app_rescue_speed_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Speed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاستعلامات البطيئة والحزم الثقيلة والتجمد أثناء العرض تُعالَج مقابل ميزانيات مقاسة.`)
};

const bn_svc_ai_app_rescue_speed_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Speed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ধীর কুয়েরি, ভারী বান্ডেল আর আটকে থাকা রেন্ডার মাপা বাজেটে ঠিক করা।`)
};

const de_svc_ai_app_rescue_speed_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Speed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langsame Abfragen, schwere Bundles und blockierende Renderer werden gegen gemessene Budgets behoben.`)
};

const es_svc_ai_app_rescue_speed_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Speed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultas lentas, paquetes pesados y renderizados bloqueantes corregidos con presupuestos medidos.`)
};

const fr_svc_ai_app_rescue_speed_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Speed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requêtes lentes, bundles lourds et rendus bloquants corrigés contre des budgets mesurés.`)
};

const pt_svc_ai_app_rescue_speed_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Speed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultas lentas, pacotes pesados e renders bloqueantes corrigidos contra orçamentos medidos.`)
};

const zh_svc_ai_app_rescue_speed_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Speed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`慢查询、臃肿打包和阻塞渲染，对照实测预算逐一修复。`)
};

const tr_svc_ai_app_rescue_speed_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Speed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yavaş sorgular, ağır paketler ve engelleyen renderlar ölçülen bütçelere karşı düzeltilir.`)
};

const ru_svc_ai_app_rescue_speed_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Speed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Медленные запросы, тяжёлые бандлы и блокирующий рендер чинятся по замеренным бюджетам.`)
};

const pl_svc_ai_app_rescue_speed_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Speed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wolne zapytania, ciężkie paczki i blokujący render naprawione wobec zmierzonych budżetów.`)
};

/**
* | output |
* | --- |
* | "Slow queries, heavy bundles and blocking renders fixed against measured budgets." |
*
* @param {Svc_Ai_App_Rescue_Speed_Desc5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_speed_desc5 = /** @type {((inputs?: Svc_Ai_App_Rescue_Speed_Desc5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_Speed_Desc5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_speed_desc5(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_speed_desc5(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_speed_desc5(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_speed_desc5(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_speed_desc5(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_speed_desc5(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_speed_desc5(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_speed_desc5(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_speed_desc5(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_speed_desc5(inputs)
	return en_svc_ai_app_rescue_speed_desc5(inputs)
});
export { svc_ai_app_rescue_speed_desc5 as "svc_ai-app-rescue_SPEED_desc" }